import { routes } from '@/routes/routes';
import { Link } from '@tanstack/react-router';

export const DashboardFooter = () => {
  return (
    <footer className="bg-secondary mt-auto px-4 py-6 lg:px-6 lg:py-8">
      <div className="text-secondary-foreground mx-auto flex w-full max-w-305 flex-col items-center gap-4 text-center text-sm lg:flex-row lg:justify-between lg:text-base">
        <p className="lg:text-left">
          © Copyright Eternalife Limited {new Date().getFullYear()}. All rights
          reserved.
        </p>

        <nav className="flex flex-wrap items-center justify-center gap-4 lg:gap-6">
          <Link
            to={routes.legal.privacyPolicy}
            className="hover:brightness-90 active:brightness-90"
          >
            Privacy Policy
          </Link>
          <Link
            to={routes.legal.termsAndConditions}
            className="hover:brightness-90 active:brightness-90"
          >
            Terms & Conditions
          </Link>
          <Link
            to={routes.legal.returnsAndRefunds}
            className="hover:brightness-90 active:brightness-90"
          >
            Returns & Refunds
          </Link>
          <Link
            to={routes.legal.shipping}
            className="hover:brightness-90 active:brightness-90"
          >
            Shipping
          </Link>
          <Link
            to={routes.help.contactUs}
            className="hover:brightness-90 active:brightness-90"
          >
            Contact Us
          </Link>
        </nav>
      </div>
    </footer>
  );
};
